import COLOURS from 'styles/export-vars.module.scss';

export default {
  primary: COLOURS.primary,
  danger: COLOURS.danger,
  text: COLOURS.text,
  darkBlue: COLOURS.darkBlue,
  blue: COLOURS.pastelBlue,
  white: COLOURS.white,
  darkGrey: COLOURS.darkGrey,
  success: COLOURS.success,
  warning: COLOURS.warning,
  auroraCyan: COLOURS.auroraCyan,
  auroraMint: COLOURS.auroraMint,
  auroraAmber: COLOURS.auroraAmber,
  auroraRed: COLOURS.auroraRed,
  auroraViolet: COLOURS.auroraViolet,
  auroraIndigo: COLOURS.auroraIndigo,
  auroraTextMuted: COLOURS.auroraTextMuted
};
